import Resource from '../../resource/Resource';
import { SET_ENROLMENTS } from './actions';
import { ENROLMENT } from '../resourceNames';
import { currentUserEnrolmentsSortedByCourseCohortSelector } from './selectors';

export function setEnrolments(enrolments) {
  return (dispatch) =>
    dispatch({
      type: SET_ENROLMENTS,
      enrolments,
    });
}

export function validateExtraData(cohort) {
  return (dispatch, getState) => {
    const state = getState();
    const enrolments = currentUserEnrolmentsSortedByCourseCohortSelector(state);
    const enrolment = enrolments
      .filter((x) => x.get('cohortPath') === cohort)
      .first();
    return Resource.lookup(ENROLMENT, 'validateExtraData', {
      cohort,
      extraData: enrolment ? enrolment.get('extraData') : null,
    });
  };
}
